import {
  INVALIDATE_FACTURES,
  INVALIDATE_VENTES,
  INVALIDATE_CREANCES,
  INVALIDATE_TRANSACTIONS,
  INVALIDATE_ECRITURE,
  INVALIDATE_CLIENT,
  INVALIDATE_DOSSIER,
  INVALIDATE_PRODUITS,
} from 'actions/invalidationTags';
import { ApiMananger } from 'actions/rtkquery';
import { FACTURATION_API_ROUTE } from 'routes/api/endpoints';

// Une facture emise/payee cree une Entree + ecritures + paiement :
// on invalide tout ce qui affiche ces donnees.
const TAGS_ECRITURES = [
  INVALIDATE_FACTURES,
  INVALIDATE_VENTES,
  INVALIDATE_CREANCES,
  INVALIDATE_TRANSACTIONS,
  INVALIDATE_ECRITURE,
  INVALIDATE_CLIENT,
  INVALIDATE_DOSSIER,
  INVALIDATE_PRODUITS,
];

const facturationApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    createFacture: build.mutation({
      query: (body) => ({ url: FACTURATION_API_ROUTE, method: 'POST', body }),
      invalidatesTags: [INVALIDATE_FACTURES],
    }),
    updateFacture: build.mutation({
      query: ({ id, ...body }) => ({
        url: `${FACTURATION_API_ROUTE}${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: [INVALIDATE_FACTURES],
    }),
    deleteFacture: build.mutation({
      query: ({ id }) => ({
        url: `${FACTURATION_API_ROUTE}${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [INVALIDATE_FACTURES],
    }),
    emettreFacture: build.mutation({
      query: ({ id }) => ({
        url: `${FACTURATION_API_ROUTE}${id}/emettre/`,
        method: 'POST',
      }),
      invalidatesTags: TAGS_ECRITURES,
    }),
    payerFacture: build.mutation({
      query: ({ id, ...body }) => ({
        url: `${FACTURATION_API_ROUTE}${id}/paiement/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: TAGS_ECRITURES,
    }),
    convertirDevis: build.mutation({
      query: ({ id }) => ({
        url: `${FACTURATION_API_ROUTE}${id}/convertir/`,
        method: 'POST',
      }),
      invalidatesTags: TAGS_ECRITURES,
    }),
    avoirFacture: build.mutation({
      query: ({ id, ...body }) => ({
        url: `${FACTURATION_API_ROUTE}${id}/avoir/`,
        method: 'POST',
        body: Object.keys(body).length > 0 ? body : undefined,
      }),
      invalidatesTags: TAGS_ECRITURES,
    }),
    relancerFacture: build.mutation({
      query: ({ id }) => ({
        url: `${FACTURATION_API_ROUTE}${id}/relancer/`,
        method: 'POST',
      }),
      invalidatesTags: [INVALIDATE_FACTURES],
    }),
    envoyerFacture: build.mutation({
      query: ({ id, ...body }) => ({
        url: `${FACTURATION_API_ROUTE}${id}/envoyer/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: TAGS_ECRITURES,
    }),
    annulerFacture: build.mutation({
      query: ({ id }) => ({
        url: `${FACTURATION_API_ROUTE}${id}/annuler/`,
        method: 'POST',
      }),
      invalidatesTags: TAGS_ECRITURES,
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateFactureMutation,
  useUpdateFactureMutation,
  useDeleteFactureMutation,
  useEmettreFactureMutation,
  usePayerFactureMutation,
  useConvertirDevisMutation,
  useEnvoyerFactureMutation,
  useAvoirFactureMutation,
  useRelancerFactureMutation,
  useAnnulerFactureMutation,
} = facturationApi;
